import Card from "react-bootstrap/Card";

export default function CardTitle (props)
{
    const light = props.light !== undefined && props.light !== false;
    return (
	<Card.Title className="d-flex justify-content-between align-items-center">
	    <div className="d-flex align-items-baseline gap-3">
		{props.subtitle !== undefined && (<div className={"small " + (light ? "text-light" : "text-muted")}>{props.subtitle}</div>)}
		{props.title !== undefined && (<div className={"small " + (light ? "text-white" : "")}>{props.title}</div>)}
	    </div>
	    <div className="d-flex gap-2">
		{props.children}
	    </div>
	</Card.Title>
    );
}
